<template>
	<section id="content"
			 :class="[`justify-center items-center flex-column pr`,{active: isTabActive, modal: modalWidget}, $css(styles.content, styles.contentActive)]">

		<img id="inline-loader" v-if="!widgetLoaded"
			 src="data:image/svg+xml;base64,PHN2ZyBjbGFzcz0ic3Bpbm5lciIgdmlld0JveD0iLTQgLTQgMTUxIDEwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxzdHlsZSB0eXBlPSJ0ZXh0L2NzcyI+PCFbQ0RBVEFbCiAgICAgIEBrZXlmcmFtZXMgY29sb3JzIHsKICAgICAgICAwJSB7IHN0cm9rZTogIzAwNzhGRjsgfQogICAgICAgICAgNTAlIHsgc3Ryb2tlOiAjMGUyZjVhOyB9CiAgICAgICAgICAxMDAlIHsgc3Ryb2tlOiAjMDA3OEZGOyB9CiAgICAgIH0KCiAgICAgIEBrZXlmcmFtZXMgZGFzaCB7CiAgICAgICAwJSB7IHN0cm9rZS1kYXNob2Zmc2V0OiA1NjA7IH0KICAgICAgIDUwJSB7CiAgICAgICAgICBzdHJva2UtZGFzaG9mZnNldDogMDsKICAgICAgIH0KICAgICAgIDEwMCUgeyAgIHN0cm9rZS1kYXNob2Zmc2V0OiA1NjA7IH0KICAgICAgfQogICAgICBALXdlYmtpdC1rZXlmcmFtZXMgY29sb3JzIHsKICAgICAgICAwJSB7IHN0cm9rZTogIzAwNzhmZjsgfQogICAgICAgICAgNTAlIHsgc3Ryb2tlOiAjMGUyZjVhOyB9CiAgICAgICAgICAxMDAlIHsgc3Ryb2tlOiAjMDA3OGZmOyB9CiAgICAgIH0KCiAgICAgIEAtd2Via2l0LWtleWZyYW1lcyBkYXNoIHsKICAgICAgIDAlIHsgc3Ryb2tlLWRhc2hvZmZzZXQ6IDU2MDsgfQogICAgICAgNTAlIHsKICAgICAgICAgIHN0cm9rZS1kYXNob2Zmc2V0OiAwOwogICAgICAgfQogICAgICAgMTAwJSB7ICAgc3Ryb2tlLWRhc2hvZmZzZXQ6IDU2MDsKICAgICAgIH0KICAgICAgfQogICAgICAucGF0aCB7CiAgICAgICAgc3Ryb2tlLWRhc2hhcnJheTogMjgwOwogICAgICAgIHN0cm9rZS1kYXNob2Zmc2V0OiAwOwogICAgICAgIHRyYW5zZm9ybS1vcmlnaW46IGNlbnRlcjsKICAgICAgICAtd2Via2l0LWFuaW1hdGlvbjoKICAgICAgICAgIGRhc2ggMnMgZWFzZS1pbi1vdXQgaW5maW5pdGUsIGNvbG9ycyA4cyBlYXNlLWluLW91dCBpbmZpbml0ZTsKICAgICAgICBhbmltYXRpb246CiAgICAgICAgICBkYXNoIDJzIGVhc2UtaW4tb3V0IGluZmluaXRlLCBjb2xvcnMgOHMgZWFzZS1pbi1vdXQgaW5maW5pdGU7CiAgICAgIH0KICAgIF1dPjwvc3R5bGU+CiAgPHBhdGggY2xhc3M9InBhdGgiIGQ9Ik0xMjEuNjYzIDkwLjYzOGMtMS43OTYgMC05OS4zMy0uNDk4LTEwMS40NzQtMS40NzhDOC42ODUgODMuODc3IDEuMjUgNzIuMTk2IDEuMjUgNTkuMzk2YzAtMTYuNjU2IDEyLjc5Ny0zMC42MSAyOS4wNTItMzIuMzIzIDcuNDktMTUuNzA2IDIzLjE4Ni0yNS43MDcgNDAuNzE0LTI1LjcwNyAyMC45OCAwIDM5LjIxNSAxNC43NTIgNDMuOTQ1IDM0LjkwNyAxNS4wOS4yNDUgMjcuMjkgMTIuNjMgMjcuMjkgMjcuODIyIDAgMTEuOTY4LTcuNzM4IDIyLjU1LTE5LjI1NiAyNi4zMyIgc3Ryb2tlLXdpZHRoPSI5IiBzdHJva2UtbGluZWNhcD0icm91bmQiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPgo8L3N2Zz4K"/>

		<Widget/>

		<div id="thumbnails-container" :class="[`overflow-hidden`, {pr: !modalWidget, absolute: modalWidget}, $css(styles.thumbs)]">
			<h1 class="fw3">Uploaded:</h1>
		</div>
	</section>
</template>

<script>
	import {mapState} from "vuex";
	import consts from "@/common/consts";
	import {getInMediaQuery as gimq, MQ_SIZES} from "@/utils/cssUtils";
	import Widget from "./Widget";

	function styles() {
		return this.$style({
			content: gimq(
				[MQ_SIZES.W, {
					width: "100%", justifyContent: "space-between",
					padding: this.modalWidget ? "0" : "20px 0 42px"}],
				[MQ_SIZES.D, {padding: "0", display: "none", justifyContent: "center"}]),
			contentActive: this.isTabActive ?
				gimq(
					[MQ_SIZES.D, {display: "flex"}],
					[MQ_SIZES.S, {minHeight: "750px", justifyContent: "flex-start"}]) : {},
			thumbs: gimq(MQ_SIZES.S, {maxHeight: "140px"}),
		});
	}

	export default {
		name: "PreviewTab",
		components: {
			Widget
		},
		computed: {
			...mapState({
				isTabActive: (state) => (state.app.activeTab === consts.TABS.PREVIEW),
				modalWidget: (state) => state.widget.modal,
				widgetLoaded: (state) => state.app.widgetLoaded,
			}),
			styles
		},
	}
</script>

<style lang="scss">
	@import "../../assets/scss/_variables.scss";

	#content {
		width: 68.3%;
		min-height: 900px;
		display: flex;
	}

	#inline-loader {
		width: 60px;
		height: 40px;
	}

	#thumbnails-container {
		background: $heather;
		position: absolute;
		width: 100%;
		bottom: 0;
		min-height: 140px;
		max-height: 220px;
		overflow-y: auto;
		padding: 10px 20px;

		h1 {
			font-size: 24px;
			line-height: 28px;
			margin: 0 0 23px;
		}

		.cloudinary-thumbnails{

			margin: 0;

			.cloudinary-thumbnail {
				position: relative;

				.cloudinary-delete {
					width: 13px;
					height: 13px;
					border-radius: 100%;
					color: $white;
					background: $orange;
					box-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);
					text-align: center;
					font-size: 11px;
					line-height: 11px;
					z-index: 5;
					position: absolute;
					padding-right: 1px;
					padding-top: 1px;
					top: -5px;
					right: -6px;
				}
			}
		}

	}
</style>
